/** Wraps the content of both stacks pages, so tests can scope queries away from the dashboard sidebar. */
export const STACKS_CONTENT_TEST_ID = 'repo-stacks-content'
